import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'root/hooks/useAuth';
import { useModal } from 'root/hooks/useModal';
import { FormattedMessage } from 'react-intl';
import { intl } from 'components/LocaleProvider';
import { FacebookLogin, GoogleLogin } from 'components/UI';
import NavLink from 'components/NavLink';

import SignUpForm from './SignUpForm';
import messages from './messages';

const SignUpModal = () => {
  const { actionsAuth } = useAuth();
  const { handleOpenModal } = useModal();

  const signUp = (data) => {
    actionsAuth.signUp(data);
  };

  return (
    <div>
      <FacebookLogin action={(data) => signUp(data)} label={intl.formatMessage(messages.labelSignUpFacebook)} />
      <GoogleLogin action={(data) => signUp(data)} label={intl.formatMessage(messages.labelSignUpGoogle)} />
      <hr className="margin-top-x-medium margin-bottom-x-medium" />
      <div className="align-center position-relative box-text-divider">
        <p style={{ margin: 0 }}>
          <FormattedMessage {...messages.divider} />
        </p>
      </div>
      <SignUpForm onSubmit={(data) => signUp(data)} />
      <div className="align-center">
        <NavLink
          className="highlight grey-border margin-top-small"
          onClick={() => handleOpenModal('signInModal')}
          dataGoogleInterstitial="false"
        >
          <FormattedMessage {...messages.labelLinkHaveAccount} />
        </NavLink>
      </div>
    </div>
  );
};

SignUpModal.propTypes = {
  signUp: PropTypes.func
};

export default SignUpModal;
